<template><div class="main">
  <sticky-bar>Billing</sticky-bar>
  <div class="padded">
    <div v-if="!accounts">
      <loading v-if="accountsLoading" />
      <button v-else class="error" @click="$store.dispatch('fetchBillingAccounts')">
        An error occurred. Click here to retry
      </button>
    </div>
    <div v-else-if="accounts.length">
      Select an account:
      <div class="billing-accounts">
        <router-link v-for="a in accounts" :key="a.id" :to="`/billing/${a.id}`">
          <div class="row">
            <span class="title" v-html="a.name" />
            <span class="id">(#{{ a.id }})</span>
          </div>
          <table>
            <tr><th>Owner</th><td>{{a.owner.firstName}} {{a.owner.lastName}}</td></tr>
            <tr><th>Amount Due</th><td>{{a.amountDue}}</td></tr>
            <tr><th>Invoice Date</th><td>{{a.invoiceDate}}</td></tr>
          </table>
        </router-link>
      </div>
    </div>
    <div v-else>
      You do not have ownership of any billing accounts.
    </div>
  </div>
</div></template>
<script>
import api from '../api'
import Loading from './Loading'
import StickyBar from './StickyBar'
export default {
  name: 'billing',
  components: { Loading, StickyBar },
  created() {
    this.$store.dispatch('fetchBillingAccounts', true)
    this.checkAutoNav()
  },
  computed: {
    user() { return this.$store.state.user },
    accounts() { return this.$store.state.billingAccounts },
    accountsLoading() { return (this.$store.state.billingAccountsRef !== null) },
  },
  methods: {
    checkAutoNav() {
      if (this.accounts && this.accounts.length === 1)
        this.$router.push(`/billing/${this.accounts[0].id}`)
    },
  },
  watch: {
    accounts() { this.checkAutoNav() },
  },
}
</script>
<style lang="scss" scoped>
.billing-accounts {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  a {
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 16px;
    background-color: #fff;
    flex-basis: 0;
    text-decoration: none;
    .row { display: flex; gap: 5px; align-items: baseline; }
    .title { font-weight: bold; }
    .id { font-size: 80%; }
    display: flex;
    flex-direction: column;
    gap: 5px;
    table {
      border-collapse: collapse;
      font-size: 80%;
      white-space: nowrap;
      th, td { border: 1px solid #aaa; padding: .1em .3em; }
    }
  }
}
</style>
